import { combineReducers } from "redux";
import LoginReducer from "./LoginReducer";
import UserReducer from "./UserReducer";
import LayoutReducer from "./LayoutReducer";
import ScrumBoardReducer from "./ScrumBoardReducer";
import NotificationReducer from "./NotificationReducer";
import EcommerceReducer from "./EcommerceReducer";
import approvalReducer from "./approvalReducer";
import iouReducer from "./iouReducer";
import reversalReducer from "./reversalReducer";
import exitReducer from "./exitReducer"; // Import the exitReducer

const RootReducer = combineReducers({
  login: LoginReducer,
  user: UserReducer,
  layout: LayoutReducer,
  scrumboard: ScrumBoardReducer,
  notification: NotificationReducer,
  ecommerce: EcommerceReducer,
  approval: approvalReducer,
  iou: iouReducer,
  reversal: reversalReducer,
  exit: exitReducer // Add the exitReducer to the combined reducers
});

export default RootReducer;
